<div class="alert alert-info bp-text bp-medium-text" role="alert">
  <i class="fas fa-info-circle"></i>
  {{ infoMsg }}
</div>



// WEBPACK FOOTER //
// ./src/app/info-message/info-message.component.html